import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ServicioUsuario } from '../../modelos/Control_Usuario/servicio-usuario';
import { Solicitud } from '../../modelos/Control_Usuario/solicitud';

@Injectable({
  providedIn: 'root',
})
export class ServicioUsuarioService {
  //Url del back
  private urlApi: string = environment.urlback;
  private httpHeadersArchivo = new HttpHeaders({
    'Content-Type': 'application/octet-stream',
  });

  constructor(private http: HttpClient) {}

  /**Retorna todos los servicios de usuario existentes */
  todosLosServiciosUsuario(): Observable<ServicioUsuario[]> {
    return this.http.get<ServicioUsuario[]>(
      `${this.urlApi}/ServicioUsuario/ListaServicioUsuario`
    );
  }

  todosLosServiciosUsuarioPorSolicitudId(
    idSolicitud: number
  ): Observable<ServicioUsuario[]> {
    return this.http.get<ServicioUsuario[]>(
      `${this.urlApi}/ServicioUsuario/ServUsuarioPorSolicitudId/${idSolicitud}`
    );
  }

  /**Servicios de usuario por id de colaborador */
  ListaServicioUPorColaboradorId(
    colaboradorId: number
  ): Observable<ServicioUsuario[]> {
    return this.http.get<ServicioUsuario[]>(
      `${this.urlApi}/ServicioUsuario/ServUsuarioPorColaboradorId/` +
        colaboradorId
    );
  }

  /**Retorna un servicio de usuario por su id */
  unServicioUsuario(idServUsuario: number): Observable<ServicioUsuario> {
    return this.http.get<ServicioUsuario>(
      `${this.urlApi}/ServicioUsuario/ServUsuarioPorIdServUsuario/` +
        idServUsuario
    );
  }

  //Actualizar status de servicio usuario //mensajes
  actualizarStatusSeUsuario(
    id_servicio_usuario: number,
    status_reg: string,
    detalle_solicitud_id: number
  ) {
    return this.http.put<string>(
      `${this.urlApi}/ServicioUsuario/ActualizarServicioUsuario?id_servicio_usuario=` +
        id_servicio_usuario +
        `&status_reg=` +
        status_reg +
        `&detalle_solicitud_id=` +
        detalle_solicitud_id,
      {}
    );
  }

  updateDatso(id: number, user: string, pass: string) {
    return this.http.put<string>(
      `${this.urlApi}/ServicioUsuario/uc/${id}?user=` + user + `&pass=` + pass,
      {}
    );
  }

  updateDatso2(
    id: number,
    user: string,
    pass: string,
    idElem: number,
    idSuc: number
  ) {
    return this.http.put<string>(
      `${this.urlApi}/ServicioUsuario/ucs/${id}/${idElem}?user=` +
        user +
        `&pass=` +
        pass +
        `&idS=` +
        idSuc,
      {}
    );
  }

  //GuardarNuevo registro de servicio Usuario
  guardarServicioUsuario(
    usuario: string,
    contrasenia: string,
    detalle_solicitud_id: number
  ) {
    return this.http.post<ServicioUsuario>(
      `${this.urlApi}/ServicioUsuario/AgregarNuevoServicioUsuario?usuario=` +
        usuario +
        `&contrasenia=` +
        contrasenia +
        `&detalle_solicitud_id=` +
        detalle_solicitud_id,
      {}
    );
  }

  /**Carga la carta responsiva al servicioUsuario*/
  cargarResponsiva(id_servUsuario: number, responsiva: File) {
    const headers2 = new HttpHeaders();
    headers2.set('Content-Type', 'application/json');
    const formData: FormData = new FormData();
    formData.append('files', responsiva);
    return this.http.put<string>(
      `${this.urlApi}/ServicioUsuario/ServicioUsuarioCargarResponsiva?id_servicio_usuario=` +
        id_servUsuario,
      formData,
      { reportProgress: true, responseType: 'json' }
    );
  }

  cargarResponsivaCarrpeta(id_servicio_usuario: number, responsiva: File) {
    const headers2 = new HttpHeaders();
    headers2.set('Content-Type', 'application/json');
    const formData: FormData = new FormData();
    formData.append('files', responsiva);
    const currentUser = JSON.parse(localStorage.getItem('currentUser') || '{}');
    return this.http.put<string>(
      `${this.urlApi}/ServicioUsuario/update/upload`,
      formData,
      {
        reportProgress: true,
        responseType: 'json',
        params: {
          id_servicio_usuario,
          usuarioNombre: currentUser.username,
          usuarioId: 1,
          usuarioNombreCompleto: currentUser.username,
        },
      }
    );
  }

  getbyResponsivaByID(id: number): Observable<any> {
    return this.http.get(`${this.urlApi}/ServicioUsuario/archivo/${id}`, {
      headers: this.httpHeadersArchivo,
      responseType: 'blob',
    });
  }

  todosLosServiciosUsuarioPaginacion(
    pagina: number,
    cantidad: number
  ): Observable<{
    total: number;
    data: ServicioUsuario[];
  }> {
    return this.http.get<{ total: number; data: ServicioUsuario[] }>(
      `${this.urlApi}/ServicioUsuario/ListaServicioUsuario/Paginacion`,
      {
        params: {
          pagina: pagina.toString(),
          cantidad: cantidad.toString(),
        },
      }
    );
  }

  todosLasSolicitudesPaginacion(
    pagina: number,
    cantidad: number,
    buscar: string
  ): Observable<{
    total: number;
    data: Solicitud[];
  }> {
    return this.http.get<{ total: number; data: Solicitud[] }>(
      `${this.urlApi}/Solicitud/ListaSolicitudes/Paginacion`,
      {
        params: {
          pagina: pagina.toString(),
          cantidad: cantidad.toString(),
          buscar,
        },
      }
    );
  }

  actualizarCredencialesServiciosUsuario(dto: any) {
    return this.http.put<boolean>(
      `${this.urlApi}/ServicioUsuario/Actualizar/Credenciales-servicios`,
      dto
    );
  }
}
